import { findByBusiType } from "@/api/common";

const dicData = {
  state: {
    rebate_approve_status: [],
    order_payment_status: [],
    rebate_type: [],
    order_payback_type: [],
    order_status: [],
    order_change_stage: [],
    order_change_type: [],
    order_change_status: [],
    device_category_icon_type: [],
    device_tag_type: [],
    device_source_type: [],
    balance_source_type: [],
    balance_account_type: [],
    balance_apply_status: [],
    balance_pay_type: [],
    order_evaluate_type: [],
    provider_type: [],
    provider_level_type: [],
    provider_settlement_type: [],
    dicLoading: {},
    msg_module_type: [],
    msg_send_type: [],
    msg_receiver_type: [],
    msg_config_status: [],
    order_report_review_status: [],
    balance_refund_status: [],
    order_from_sys:[]
  },
  mutations: {
    setDicData(state, payload) {
      state[payload.dicCode] = payload.data;
    }
  },
  actions: {
    setDicArr(context, payload) {
      console.log("判断", payload);
      payload.forEach(item => {
        console.log(item, "item");
        if (context.state[item].length === 0) {
          console.log("开始请求");
          findByBusiType(item).then(res => {
            console.log("结束", res);
            context.commit("setDicData", {
              dicCode: item,
              data: res.data
            });
          });
        }
      });
    },
    fresh(context, dicType) {
      if (
        typeof context.state[dicType] != "undefined" &&
        !!context.state[dicType].length
      ) {
        return;
      }
      // 正在加载的不进行加载
      if (context.state.dicLoading[dicType] === "true") {
        console.log("fresh dic is loading");
        return;
      } else {
        console.log("fresh begin loading", dicType);
        context.state.dicLoading[dicType] = "true";
      }
      findByBusiType(dicType).then(res => {
        context.state.dicLoading[dicType] = "false";
        console.log("fresh dic is ending");
        context.commit("setDicData", {
          dicCode: dicType,
          data: res.data
        });
      });
    }
  }
};

export default dicData



// WEBPACK FOOTER //
// ./src/store/modules/dicData.js